import {Injectable} from '@angular/core';

import {PLACE_CATEGORIES } from './PlaceCategories';

import {HEART_COLORS,MAP_MARKER_ICON,MAP_ZOOM_LEVEL} from './NeurConstants';

import {
    ExportedClass as NeurService
} from './NeurService';

import {
    ExportedClass as WeatherService
} from './WeatherService';

import * as CountryCoder from 'country-coder';

import * as L from "leaflet";

import "leaflet";
import "leaflet-quadtree";

export const MARKER_TYPE = {
    GUI: 0,
    MAP: 1,
}

export const EXPLORE_PLACE = {
    _id: -2,
    name: ['EXPLORE'],
    coordinates: {
        latitude: 0,
        longitude: 0
    },
    category: PLACE_CATEGORIES.Continent.id,
    zoom_level: MAP_ZOOM_LEVEL.WHOLE_WORLD
}

export const PLAN_PLACE = {
    _id: 0,
    name: ['PLANS'],
    coordinates: {
        latitude: 0,
        longitude: 0
    },
    category: PLACE_CATEGORIES.Continent.id,
    zoom_level: MAP_ZOOM_LEVEL.WHOLE_WORLD
}

export const FOOTPRINTS_PLACE = {
    _id: 0,
    name: ['FOOTPRINTS'],
    coordinates: {
        latitude: 0,
        longitude: 0
    },
    category: PLACE_CATEGORIES.Continent.id,
    zoom_level: MAP_ZOOM_LEVEL.WHOLE_WORLD
}

export const CURRENT_PLACE = {
    _id: -1,
    name: ['MY_LOCATION'],
    category: PLACE_CATEGORIES.Town.id,
    zoom_level: MAP_ZOOM_LEVEL.DEFAULT
}

export const PLACE_PARAMETERS = {
    NAME:1,
    COORDINATES:2,
    CATEGORY:3,
    ZOOM_LEVEL:4
}

@Injectable()
class PlaceService {
    constructor(private neurService: NeurService, private weatherService: WeatherService) {}

    private global_places = new Map();
    private map_zoom_layers = new Map();
    
    // get the icon and colors of a place 
    public getMarker(category: number, score: number, type: number, color ? : string) {
        //console.log("category: ",  category);
        const MAP_MARKER_ICON = {
            PINBASE: '<path d="M269.995 217.6a10.667 10.667 0 1 0-6.646 20.267c24.395 8 35.318 17.557 35.318 23.466 0 14.87-55.307 37.333-138.667 37.333S21.333 276.202 21.333 261.333c0-5.91 10.923-15.466 35.328-23.466a10.667 10.667 0 1 0-6.645-20.267C8.672 231.147 0 248.864 0 261.333 0 299.84 80.49 320 160 320s160-20.16 160-58.667c0-12.47-8.672-30.186-50.005-43.733z"/>',
            PINBODY: '<path d="M153.333 274.997a10.667 10.667 0 0 0 13.334 0c3.893-3.125 95.424-77.44 95.424-172.906a102.09 102.09 0 1 0-204.182 0c0 95.466 91.52 169.78 95.424 172.906z"/>',
            DOT: 'data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320"><path d="M153.333 274.997a10.667 10.667 0 0 0 13.334 0c3.893-3.125 95.424-77.44 95.424-172.906a102.09 102.09 0 1 0-204.182 0c0 95.466 91.52 169.78 95.424 172.906z"/></svg>',
            PIN: 'data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320"><path d="M153.333 274.997a10.667 10.667 0 0 0 13.334 0c3.893-3.125 95.424-77.44 95.424-172.906a102.09 102.09 0 1 0-204.182 0c0 95.466 91.52 169.78 95.424 172.906z"/></svg>',
        }

        const TRANSPORTATION = [PLACE_CATEGORIES.Plane.id, PLACE_CATEGORIES.Train.id, PLACE_CATEGORIES.Plane.id, PLACE_CATEGORIES.Bus.id, PLACE_CATEGORIES.Subway.id, PLACE_CATEGORIES.CommuterRail.id,
            PLACE_CATEGORIES.Monorail.id, PLACE_CATEGORIES.Taxi.id, PLACE_CATEGORIES.ShareRide.id, PLACE_CATEGORIES.AerialTramway.id, PLACE_CATEGORIES.InclinedRail.id,
            PLACE_CATEGORIES.Walking.id, PLACE_CATEGORIES.Biking.id, PLACE_CATEGORIES.Driving.id, PLACE_CATEGORIES.Taxi.id, PLACE_CATEGORIES.BicycleSharing.id,
            PLACE_CATEGORIES.Boat.id, PLACE_CATEGORIES.Ferry.id, PLACE_CATEGORIES.CarFerry.id, PLACE_CATEGORIES.RailFerry.id, PLACE_CATEGORIES.Ship.id,
        ]
        const EAT_ACCOMMODATION = [PLACE_CATEGORIES._EAT_DRINK.id, PLACE_CATEGORIES._ACCOMMODATION.id]

        let map_dot = MAP_MARKER_ICON.DOT.replace('<path ', '<path fill="' + HEART_COLORS[score] + '" ');
        let map_pin = MAP_MARKER_ICON.PIN.replace('<path ', '<path fill="' + HEART_COLORS[score] + '" ');

        const ICON = {
            HEADER: 'data:image/svg+xml;utf-8,<svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg">',
            FOOTER: '</svg>',
        }

        const findSubobject = (obj: any, id: number): any | undefined => {
            for (const key in obj) {
                if (obj[key] && obj[key].id === id) {
                    return obj[key];
                }
            }
            return undefined;
        };
        const categoryNode = findSubobject(PLACE_CATEGORIES, category);
        let background = 'silver',
            icon = '';
        try {
            if (categoryNode != undefined) {
                if (categoryNode.background != undefined) {
                    background = categoryNode.background;
                } else {
                    let subcategoryNode = findSubobject(PLACE_CATEGORIES, Math.floor(category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK +
                        Math.floor((category % PLACE_CATEGORIES.MAIN_CATEGORY_MASK) / PLACE_CATEGORIES.SUB_CATEGORY_MASK) * PLACE_CATEGORIES.SUB_CATEGORY_MASK);
                    if (subcategoryNode.background != undefined) {
                        background = subcategoryNode.background;
                    } else {
                        let mainCategoryNode = findSubobject(PLACE_CATEGORIES, Math.floor(category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK);
                        if (mainCategoryNode.background != undefined) {
                            background = mainCategoryNode.background;
                        }
                    }

                }
                if (categoryNode.icon != undefined) {
                    icon = categoryNode.icon;
                } else {

                    let subcategoryNode = findSubobject(PLACE_CATEGORIES, Math.floor(category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK +
                        Math.floor((category % PLACE_CATEGORIES.MAIN_CATEGORY_MASK) / PLACE_CATEGORIES.SUB_CATEGORY_MASK) * PLACE_CATEGORIES.SUB_CATEGORY_MASK);
                    if (subcategoryNode.icon != undefined) {
                        icon = subcategoryNode.icon;
                    } else {
                        let mainCategoryNode = findSubobject(PLACE_CATEGORIES, Math.floor(category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK);
                        if (mainCategoryNode.icon != undefined) {
                            icon = mainCategoryNode.icon;
                        }
                    }

                }
            }
        } catch (e) {
            console.log(e)
        };

        if (color) {
            icon = '<g fill="' + color + '">' + icon + '</g>';
        }
        switch (type) {
            case MARKER_TYPE.GUI:
                icon = ICON.HEADER + icon + ICON.FOOTER;
                let base = Math.floor(category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK;
                let type = TRANSPORTATION.includes(category) ? PLACE_CATEGORIES._TRANSPORTATION.id : (EAT_ACCOMMODATION.includes(base) ? base : category);
                return {
                    icon: icon,
                        color: background,
                        type: type
                };
                break;
            case MARKER_TYPE.MAP:
                icon = ICON.HEADER + MAP_MARKER_ICON.PINBODY.replace('<path ', '<path fill="' + background + '" ') + MAP_MARKER_ICON.PINBASE.replace('<path ', '<path fill="' + HEART_COLORS[score] + '" ') + icon + ICON.FOOTER;
                return {
                    icon: icon, dot: map_dot, pin: map_pin
                };
                break;
        }
    }

    public makeMarkers(place: any): any {
        //console.log("in makeMarker: place = ", place);
        if (!place.hasOwnProperty('gui_marker')) {
            place.gui_marker = this.getMarker(place.category, place.overall_score, MARKER_TYPE.GUI);
        }
        if (!place.hasOwnProperty('map_marker')) {
            place.map_marker = this.getMarker(place.category, place.overall_score, MARKER_TYPE.MAP, "white");
        }
        return place;
    }

    public getPlaceZoomLevel (category){
        let zoomLevel;
        switch (category) {
                case PLACE_CATEGORIES.Continent.id:
                case PLACE_CATEGORIES.City.id + PLACE_CATEGORIES.Country.id:
                    zoomLevel = MAP_ZOOM_LEVEL.SUBCONTINENTAL;
                    break;
                case PLACE_CATEGORIES.Country.id:
                    zoomLevel = MAP_ZOOM_LEVEL.SMALL_COUNTRY;
                    break;
                case PLACE_CATEGORIES.StateProvince.id:
                    zoomLevel = MAP_ZOOM_LEVEL.SMALL_COUNTRY;
                    break;
                case PLACE_CATEGORIES.City.id:
                    zoomLevel = MAP_ZOOM_LEVEL.CITY;
                    break;
                case PLACE_CATEGORIES.Town.id:
                    zoomLevel = MAP_ZOOM_LEVEL.CITY_DISTRICT;
                    break;
                default:
                    zoomLevel = MAP_ZOOM_LEVEL.DEFAULT;
                    break;
            }
        return zoomLevel;
    }
    
    public async updatePlace(place, coordinates?, category ? , zoomLevel ? ) {
        
        if (!zoomLevel && !category) {
            category = place.category;
            zoomLevel = place.zoom_level;
        } else if (!zoomLevel) {
            switch (category) {
                case PLACE_CATEGORIES.Continent.id:
                    zoomLevel = MAP_ZOOM_LEVEL.SUBCONTINENTAL;
                    break;
                case PLACE_CATEGORIES.Country.id:
                    zoomLevel = MAP_ZOOM_LEVEL.SMALL_COUNTRY;
                    break;
                case PLACE_CATEGORIES.StateProvince.id:
                    zoomLevel = MAP_ZOOM_LEVEL.SMALL_COUNTRY;
                    break;
                case PLACE_CATEGORIES.City.id:
                    zoomLevel = MAP_ZOOM_LEVEL.CITY_DISTRICT;
                    break;
                case PLACE_CATEGORIES.Town.id:
                    zoomLevel = MAP_ZOOM_LEVEL.CITY_DISTRICT;
                    break;
            }
        } else if (!category) {
            switch (zoomLevel) {
                case MAP_ZOOM_LEVEL.SUBCONTINENTAL:
                    category = PLACE_CATEGORIES.Continent.id;
                    break;
                case MAP_ZOOM_LEVEL.SMALL_COUNTRY:
                    category = PLACE_CATEGORIES.Country.id;
                    break;
                case MAP_ZOOM_LEVEL.CITY:
                    category = PLACE_CATEGORIES.City.id;
                    break;
                case MAP_ZOOM_LEVEL.CITY_DISTRICT:
                    category = PLACE_CATEGORIES.Town.id;
                    break;
            }
        }
        if (coordinates) {
            place.coordinates=coordinates;
        }
        place.category=category;
        place.zoom_level=zoomLevel;

        /*            weather = await this.weatherService.getCurrentWeatherInfo(this.neurService.current_location.latitude,this.neurService.current_location.longitude);
                    if (weather){
        console.log('get weather...')
                    }
        console.log('place '+JSON.stringify(place))
        */
        return place;
    }
    
    public clone(place) {
        let pl = JSON.parse(JSON.stringify(place));
        return pl;
    }

    public static isPOI (category){
        let mask_result = Math.floor(category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK;
        return ![PLACE_CATEGORIES._TRANSPORTATION.id].includes(mask_result);
    }
    
    public set(place){
        this.global_places.set(place._id,place);
    }
    
    public get(place_id) {
        return this.global_places.get(place_id);
    }
    
    public remove(place_id) {
            this.global_places.delete(place_id);
    }
    
    public has(place_id){
        return this.global_places.has(place_id);
    }
    
    public setupMapZoomLayers (){
        for (let z = 0; z< 20; z++ ){
            let quadTree = L.quadtree({maxObjectsPerLevel: Math.floor(5+(20-z)/2), maxLevels: Math.floor(10+(20-z)/2)});
            let zoomLayer = {quadtree:quadTree, explored:null,requested:new Map()}
            this.map_zoom_layers.set(z,zoomLayer);
        }
    }
    
    public addMarker(zoomLevel,marker) {
        this.map_zoom_layers.get(zoomLevel).quadtree.add(marker);
    }
    
    public getMarkers(zoomLevel,bounds){
        return this.map_zoom_layers.get(zoomLevel).quadtree.getColliders(bounds);
    }
    
    public setExploredArea(zoomLevel,exploredArea){
        this.map_zoom_layers.get(zoomLevel).explored = exploredArea;   
    }
    
    public getExploredArea(zoomLevel) {
        return this.map_zoom_layers.get(zoomLevel).explored;
    }
    
    public setRequestedArea(zoomLevel,requestedArea){
        this.map_zoom_layers.get(zoomLevel).requested = requestedArea;   
    }
    
    public getRequestedArea(zoomLevel) {
        return this.map_zoom_layers.get(zoomLevel).requested;
    }
}

/*
    Service class should be exported as ExportedClass
*/
export {
    PlaceService as ExportedClass
};